const groupPrefix = createApiRoute(ApiModule.CLIENT, ApiAuthorization.EMPLOYEE, ApiDataModel.PROMOTIONS)

export const apiPromotions = {
	updatePromotion: async (promotionID: number, form: any) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}/${promotionID}`, {
			method: 'PUT',
			body: promotionToJSON(form),
		})
		return Promotion(data)
	},

	storePromotion: async (form: any) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}`, {
			method: 'POST',
			body: promotionToJSON(form),
		})
		return Promotion(data)
	},

	fetchDiscounts: async (
		status: EPromotionStatus[] | undefined,
		type: EPromotionType[] | undefined,
		search: string | undefined,
		page: number = 1,
		perPage: number = 25,
	) => {
		const isActive = status?.includes(EPromotionStatus.ACTIVE)
		const isInactive = status?.includes(EPromotionStatus.INACTIVE)
		let activeFilter: string[] | undefined
		if (isActive && isInactive) activeFilter = ['true', 'false']
		else if (isActive) activeFilter = ['true']
		else if (isInactive) activeFilter = ['false']
		const { data, meta } = await apiCommon<IPromotion[]>(`${groupPrefix}`, {
			method: 'GET',
			...createQuery(
				{ page, perPage },
				{ is_active: activeFilter, action_type: type, coupon_code: search },
				{ id: EApiSortType.DESC },
			),
		})
		return { data: data.map(d => Promotion(d)), meta }
	},

	fetchPromotion: async (codeID: number) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}/${codeID}`, {
			method: 'GET',
		})
		return { data: Promotion(data) }
	},

	deletePromotion: async (promotionID: string) =>
		await apiCommon<IPromotion>(`${groupPrefix}/${promotionID}`, { method: 'DELETE' }),

	updatePromotionBulk: async (promotionIDs: number[], isActive: boolean) => {
		const { data } = await apiCommon<IPromotion>(`${groupPrefix}/update-many`, {
			method: 'PUT',
			body: { ids: promotionIDs, is_active: isActive },
		})
		return Promotion(data)
	},

	deletePromotionBulk: async (promotionIDs: number[]) =>
		await apiCommon<IPromotion>(`${groupPrefix}/destroy-many`, {
			method: 'DELETE',
			body: { ids: promotionIDs },
		}),
}
